import React from "react";
import { ImgV2 } from "../../../ImgV2";
export const FeaturesList = ({ featureTitle, imageUrl }) => (React.createElement("div", { className: 'features-list__root' },
    React.createElement(ImgV2, { src: imageUrl, alt: imageUrl }),
    React.createElement("p", { className: 'feature-title' }, featureTitle)));
